import { useMemo } from 'react';
import { useSupplierSelectListQuery } from 'api';

export const useSupplierMapping = (): Record<string, any> => {
  const { data: supplierList = [] } = useSupplierSelectListQuery();
  const supplierMapping: Record<string, { name: string; id: string }> = useMemo(() => {
    const mapping: Record<string, { name: string; id: string }> = {};
    supplierList.forEach((i: { name: string; id: string }) => {
      mapping[i.id] = i;
    });
    return mapping;
  }, [supplierList]);

  return {
    supplierMapping,
  };
};
